import React, { useEffect,Suspense} from 'react'
////import WhyChooseUsPage from '../components/why-choose-us/Why-Choose-Us'
const WhyChooseUsPage = React.lazy(() => import('../components/why-choose-us/Why-Choose-Us'));
import { useAppContext } from "../Context/Store"; 

export default function WhyChooseUs({ sendBodyClass }) {

  const { isError, isLoading, whychooseUsData } = useAppContext();

  if(isError){
    //console.log("Home Page Component", contextData); 
    return <div>Error Why Choose Us Page...</div>;  // Handle Error state
  }
  
  if (!whychooseUsData || isLoading) {
    return <div>Loading...</div>;  // Handle loading state
  }
  
  const { properties } = whychooseUsData;
  useEffect(() => {
    sendBodyClass(false);
  },[])
  return (
    <>
    <Suspense fallback={<div>Loading...</div>}>
        <WhyChooseUsPage ChooseUsData={properties?.descriptionText || " "} />
        </Suspense>
    </>
  )
}
